import { ThemeProvider } from "@mui/material/styles";
import React from "react";
import { useSelector } from "react-redux";
import themeConfigs from "./configs/themeConfig";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import routes from "./routes/router";
import {  CssBaseline } from "@mui/material";
import "./sass/style.css";

import MainLayout from "./components/layout/MainLayout";

function App() {
  const { themeMode } = useSelector((state) => state.themeMode);
  console.log(themeMode);
  return (
    <ThemeProvider theme={themeConfigs.custom({ mode: themeMode })}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            {routes.map((route, index) => (
              <Route element={route.element} path={route.path} />
            ))}
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
